import axios from '../../axios'
import { GET_CALL_HISTORY } from './callTypes'

import { URL_GET_CALL_HISTORY } from './callUrls'
import { ResponseModel, STATUS_OK } from '../../models/network/response_model'
// import { dirname } from 'path'

export default {
  [GET_CALL_HISTORY]({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(URL_GET_CALL_HISTORY, { params })
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_CALL_HISTORY, data);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },
}
